var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfil(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_585_2008)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.98137 10.3125C2.77116 9.47981 3.72013 8.87406 4.71953 8.54416C3.72375 7.64609 3.09678 6.34659 3.09678 4.90322C3.09678 2.19959 5.29638 0 8 0C10.7036 0 12.9032 2.19959 12.9032 4.90322C12.9032 6.34656 12.2762 7.64609 11.2805 8.54419C12.28 8.87409 13.2288 9.47981 14.0186 10.3125C15.2963 11.6596 16 13.4045 16 15.2258V16H0V15.2258C0 13.4045 0.703688 11.6596 1.98137 10.3125ZM11.3548 4.90322C11.3548 3.05338 9.84987 1.54838 8 1.54838C6.15016 1.54838 4.64516 3.05334 4.64516 4.90322C4.64516 6.75306 6.15013 8.25806 8 8.25806C9.84984 8.25806 11.3548 6.75309 11.3548 4.90322ZM14.3971 14.4516C14.0128 11.7463 11.6659 9.80647 9.54841 9.80647H6.45162C4.33416 9.80647 1.98722 11.7463 1.60291 14.4516H14.3971Z",
    fill: "#3F3F46"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_585_2008"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "matrix(-1 0 0 1 16 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfil);
export default __webpack_public_path__ + "static/media/profil.1bffc37d795e3f67c161466578ddc232.svg";
export { ForwardRef as ReactComponent };